// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2sUUT","head":"Table_head__1Z7Ql","col":"Table_col__1gdfw"};